const POLL_INTERVAL = 15000

function fetchVersion () {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest()
    request.open('GET', '/version.json?_=' + Date.now(), true)
    request.timeout = 5000
    request.setRequestHeader('Cache-Control', 'no-cache')
    request.onload = () => {
      if (request.status !== 200) return reject(new Error('Version unavailable'))
      try { resolve(JSON.parse(request.responseText)) } catch (error) { reject(error) }
    }
    request.onerror = request.ontimeout = () => reject(new Error('Version unavailable'))
    request.send()
  })
}

function createVersionMonitor (options) {
  const request = options.request || fetchVersion
  const schedule = options.schedule || setInterval
  const unschedule = options.unschedule || clearInterval
  let timer = null
  let running = false
  let pending = false
  function check () {
    if (!running || pending) return Promise.resolve()
    pending = true
    return Promise.resolve().then(request).then(latest => {
      if (!running || !latest || latest.schema !== 1 || typeof latest.revision !== 'string' || !/^[a-f0-9]{64}$/.test(latest.revision)) return
      options.onChange(latest.revision !== options.revision ? latest.revision : null)
    }).catch(() => {
      // Offline, missing manifests and transient errors are not new releases.
    }).then(() => { pending = false })
  }
  return {
    start () {
      if (running) return
      running = true
      check()
      timer = schedule(check, POLL_INTERVAL)
    },
    check,
    stop () {
      running = false
      if (timer !== null) unschedule(timer)
      timer = null
    }
  }
}
export { createVersionMonitor, POLL_INTERVAL }



// WEBPACK FOOTER //
// ./src/services/version-monitor.js